var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.955,23.672H35.112c-3.851,0-6.983,3.133-6.983,6.983v35.456c0,3.851,3.132,6.983,6.983,6.983h28.843 c1.104,0,2-0.896,2-2s-0.896-2-2-2H35.112c-1.645,0-2.983-1.338-2.983-2.983c0-1.645,1.338-2.982,2.983-2.982h28.843 c1.104,0,2-0.896,2-2V25.672C65.955,24.568,65.06,23.672,63.955,23.672z M61.955,59.129H35.112c-1.068,0-2.077,0.248-2.983,0.678 V30.656c0-1.645,1.338-2.983,2.983-2.983h26.843V59.129z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.955,64.111H35.112c-1.104,0-2,0.896-2,2s0.896,2,2,2h28.843c1.104,0,2-0.896,2-2S65.06,64.111,63.955,64.111z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.5530302d1e402ba414c92cf857be8227.svg";
export { ForwardRef as ReactComponent };